import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClaimInsentifPage } from './claim-insentif.page';

const routes: Routes = [
  {
    path: '',
    component: ClaimInsentifPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClaimInsentifPageRoutingModule {}
